// Generated by purs version 0.13.8
"use strict";
var Control_Monad_Cleanup = require("../Control.Monad.Cleanup/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Effect = require("../Effect/index.js");
var Slot = (function () {
    function Slot(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Slot.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Slot(value0, value1, value2);
            };
        };
    };
    return Slot;
})();
var MonadReplace = function (Monad0, MonadCleanup1, newSlot) {
    this.Monad0 = Monad0;
    this.MonadCleanup1 = MonadCleanup1;
    this.newSlot = newSlot;
};
var replaceSlot = function (v) {
    return v.value0;
};
var newSlot = function (dict) {
    return dict.newSlot;
};
var destroySlot = function (v) {
    return v.value1;
};
var appendSlot = function (v) {
    return v.value2;
};
var monadReplaceReaderT = function (dictMonadReplace) {
    return new MonadReplace(function () {
        return Control_Monad_Reader_Trans.monadReaderT((dictMonadReplace.MonadCleanup1()).Monad0());
    }, function () {
        return Control_Monad_Cleanup.monadCleanupReaderT(dictMonadReplace.MonadCleanup1());
    }, (function () {
        var slotWith = function (env) {
            return function (slot) {
                return new Slot(function (m) {
                    return replaceSlot(slot)(Control_Monad_Reader_Trans.runReaderT(m)(env));
                }, destroySlot(slot), Data_Functor.map(Effect.functorEffect)(slotWith(env))(appendSlot(slot)));
            };
        };
        return Control_Monad_Reader_Trans.ReaderT(function (env) {
            return Data_Functor.map(((((dictMonadReplace.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(slotWith(env))(newSlot(dictMonadReplace));
        });
    })());
};
module.exports = {
    newSlot: newSlot,
    Slot: Slot,
    replaceSlot: replaceSlot,
    destroySlot: destroySlot,
    appendSlot: appendSlot,
    MonadReplace: MonadReplace,
    monadReplaceReaderT: monadReplaceReaderT
};
//# sourceMappingURL=index.js.map
